import React from 'react';

export default function CardContact(props) {
 

 

  return (
    <div className="cardContainer cardContainer2 cardInput">
      <div className="contactTitle titleMain">Contact Information</div>

      <div className="CardInput cardInputContact">
        <input required type="text"  name='first_name' defaultValue={props?.Contactvalues[0]} onChange={props.handleChange}/>
        <label>First Name</label>
      </div>
      <div className="CardInput  cardInputContact">
        <input required type="text" name='surname' defaultValue={props?.Contactvalues[1]} onChange={props.handleChange}/>
        <label>Surname</label>
      </div>
      <div className=" CardInputuser CardInput cardInputContact">
        <input required type="text" readOnly name='email' defaultValue={props?.Contactvalues[2]} onChange={props.handleChange}/>
        <label>Email</label>
      </div>
      <div className="CardInput cardInputContact">
        <input required type="text" name='phone' defaultValue={props?.Contactvalues[3]} onChange={props.handleChange}/>
        <label>Phone</label>
      </div>
    </div>
  );
}
